import { EstadoDomicilio } from './domicilios.models';

/* Opciones del estado del domicilio */
export const OPCIONES_ESTADO_DOMICILIO: {
  nombre: string;
  valor: EstadoDomicilio;
}[] = [
  { nombre: 'Cancelado', valor: EstadoDomicilio.CANCELADO },
  { nombre: 'En Bodega', valor: EstadoDomicilio.BODEGA },
  { nombre: 'Ruta Asignada', valor: EstadoDomicilio.RUTA },
  { nombre: 'Despachado', valor: EstadoDomicilio.DESPACHADO },
  { nombre: 'Entregado', valor: EstadoDomicilio.ENTREGADO },
  { nombre: 'Fallido', valor: EstadoDomicilio.FALLIDO },
  {
    nombre: 'Re-programado',
    valor: EstadoDomicilio.REPROGRAMADO,
  },
];

/* Estados de domicilio fallido */
export const ESTADOS_DOMICILIO_FALLIDO = [
  EstadoDomicilio.FALLIDO,
  EstadoDomicilio.REPROGRAMADO,
];

/* Estados de domicilio completado (entregado o fallido) */
export const ESTADOS_DOMICILIO_COMPLETADO = [
  ...ESTADOS_DOMICILIO_FALLIDO,
  EstadoDomicilio.ENTREGADO,
];

/* Estados de domicilio donde ya fue despachado */
export const ESTADOS_DOMICILIO_DESPACHADO = [
  ...ESTADOS_DOMICILIO_COMPLETADO,
  EstadoDomicilio.DESPACHADO,
];

/* Estados de domicilio donde ya fue enrutado */
export const ESTADOS_DOMICILIO_RUTA = [
  ...ESTADOS_DOMICILIO_DESPACHADO,
  EstadoDomicilio.RUTA,
];

/* Estados de domicilio donde ya están en bodega */
export const ESTADOS_DOMICILIO_BODEGA = [
  ...ESTADOS_DOMICILIO_RUTA,
  EstadoDomicilio.BODEGA,
];
